import React, {useEffect, useState} from "react";
import BlogImagePopper from "./BlogImageLarge";
import zoomImg from "../../../../assets/icons/imgBtn.svg";
import image24 from "../../../../assets/images/Blog46/image24.png";
import image33 from "../../../../assets/images/Blog46/image33.png";
import image15 from "../../../../assets/images/Blog46/image15ChinaTraderecord.png";
import image14 from "../../../../assets/images/Blog46/image14.png";
import image2 from "../../../../assets/images/Blog46/image2.png";
import image11 from "../../../../assets/images/Blog46/image11.png";
import image6 from "../../../../assets/images/Blog46/image6.png";
import image7 from "../../../../assets/images/Blog46/image7.png";
import image15New from "../../../../assets/images/Blog46/image15Chinaedgingup_.png";
import image16 from "../../../../assets/images/Blog46/image16.png";
import image37 from "../../../../assets/images/Blog46/image37.png";
import image18 from "../../../../assets/images/Blog46/image18.png";
import image20 from "../../../../assets/images/Blog46/image20.png";
import image26 from "../../../../assets/images/Blog46/image26.png";
import image32 from "../../../../assets/images/Blog46/image32.png";
import image79 from "../../../../assets/images/Blog46/image79.png";
import image82 from "../../../../assets/images/Blog46/image82.png";
import image86 from "../../../../assets/images/Blog46/image86.png";
const Blog46 = () => {
  const [selectedImage, setSelectedImage] = useState(null);
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  const handleRedirect = (url) => {
    window.open(url, "_blank");
  };
  const handleLargeImg = (img) => {
    setSelectedImage(img);
  };
  return (
    <div className="MainNewBlog">
      <div className="blogHeader">
        <h2 className="headerBoldText mainHeader">Weekly Market Outlook – December 8th, 2025</h2>
      </div>
      <div className="blogContentnew">
        <p className="highlightedBoldText ">Liquidity Stabilises, Macro Signals Split, and Markets Brace for a Defining Fed Week</p>
        <p>
          What started as another shaky December stretch — weighed down by crypto volatility, liquidity distortions, and geopolitical rumblings — ended with markets showing notable resilience. Forced
          liquidations faded, Treasury settlement pressures eased, and flow dynamics turned supportive again. Despite softening in smaller-business labour data and mixed macro signals, equities clawed
          back higher as volatility collapsed and positioning normalised.
        </p>
        <p>
          Yet, beneath the surface, the market tone remains fragile. The LEI/CEI recession signal has slipped into levels historically associated with downturns, the crypto structure remains unstable,
          and global policy paths have begun to diverge. With a pivotal <span className="highlightedText ">FOMC week</span> approaching, traders find themselves balancing early-December chop against
          rising seasonal tailwinds — particularly the long-observed post–Day 11 Santa impulse.
        </p>
        <hr className="divisionLine" />
        <div className="subHeader">
          <div className="contentDivWrapper flexDiv">
            <div className="contentDiv listOfRecap">
              <p className="highlightedBoldText">Market Overview: Stabilisation Through Flows, Not Fundamentals</p>
              <p>
                The stabilisation last week came almost entirely from flows rather than macro improvement. Crypto was hit hardest, pressured by structural liquidity issues and regulatory developments
                in China, while concerns around the JPY carry trade resurfaced after Japanese long-end yields climbed on potential BOJ tightening signals.
              </p>
              <p>Still, equities held firm. Breadth improved meaningfully, with more SPX components trading above key moving averages — a welcome reversal after November’s grind lower.</p>

              <div className="imageWrapperCont">
                <div className="relatedImg">
                  <img
                    src={image24}
                    alt="SPX strong internals"
                  />
                  <div
                    className="zoomBtn"
                    onClick={() => handleLargeImg(image24)}
                  >
                    <button>
                      <img
                        src={zoomImg}
                        alt=""
                      />
                    </button>
                  </div>
                </div>
              </div>
              <p>
                Institutional and retail flows also returned, even as hedge funds remained hesitant. This divergence has become a defining feature of late-2025 trading: cautious hedge funds versus
                opportunistic retail/institutional inflows.
              </p>

              <div className="imageWrapperCont">
                <div className="relatedImg">
                  <img
                    src={image33}
                    alt="retail dominant but dangerously passive"
                  />
                  <div
                    className="zoomBtn"
                    onClick={() => handleLargeImg(image33)}
                  >
                    <button>
                      <img
                        src={zoomImg}
                        alt=""
                      />
                    </button>
                  </div>
                </div>
              </div>
              <p>
                Meanwhile, China posted a <span className="highlightedText ">record trade surplus,</span> an early sign that global deflationary forces may intensify into 2026. This spillover helped
                ease input-cost pressures and offered a mild boost to global risk sentiment.
              </p>

              <div className="imageWrapperCont">
                <div className="relatedImg">
                  <img
                    src={image15}
                    alt="China Trade record"
                  />
                  <div
                    className="zoomBtn"
                    onClick={() => handleLargeImg(image15)}
                  >
                    <button>
                      <img
                        src={zoomImg}
                        alt=""
                      />
                    </button>
                  </div>
                </div>
              </div>
              <p>
                The week’s message was simple: the market isn’t celebrating macro improvement — it’s stabilising because <span className="highlightedText">positioning reset</span> and{" "}
                <span className="highlightedText">flows turned supportive.</span>{" "}
              </p>
            </div>
          </div>
        </div>
        <hr className="divisionLine" />
        <div className="subHeader">
          <div className="contentDivWrapper flexDiv ">
            <div className="contentDiv listOfRecap">
              <p className="highlightedBoldText">Macro & Policy Watch: Flat Labour, Recession Signals, and Global Policy Divergence</p>

              <p className="highlightedText">Labour Market: Weak Under the Surface, But Not Collapsing</p>
              <p>
                ADP data suggests continued softening, especially among smaller firms. The trend supports the analyst’s view that labour is weakening gradually rather than cyclically breaking down.
              </p>
              <div className="imageWrapperCont">
                <div className="relatedImg">
                  <img
                    src={image14}
                    alt="ADP suggesting new lower normal"
                  />
                  <div
                    className="zoomBtn"
                    onClick={() => handleLargeImg(image14)}
                  >
                    <button>
                      <img
                        src={zoomImg}
                        alt=""
                      />
                    </button>
                  </div>
                </div>
              </div>
              <p>At the same time, consumer sentiment indicators show signs of bottoming rather than deteriorating.</p>

              <div className="imageWrapperCont">
                <div className="relatedImg">
                  <img
                    src={image2}
                    alt="UoM bottoming?"
                  />
                  <div
                    className="zoomBtn"
                    onClick={() => handleLargeImg(image2)}
                  >
                    <button>
                      <img
                        src={zoomImg}
                        alt=""
                      />
                    </button>
                  </div>
                </div>
              </div>
              <p>Initial jobless claims moved lower — the best levels since 2022 — contradicting recession-imminent narratives driven by online commentary.</p>
              <div className="imageWrapperCont">
                <div className="relatedImg">
                  <img
                    src={image11}
                    alt="initial claims drop"
                  />
                  <div
                    className="zoomBtn"
                    onClick={() => handleLargeImg(image11)}
                  >
                    <button>
                      <img
                        src={zoomImg}
                        alt=""
                      />
                    </button>
                  </div>
                </div>
              </div>
              <p className="highlightedText">The LEI/CEI Warning</p>
              <p>
                One of the strongest recession indicators flashed again: the LEI/CEI ratio fell to <span className="highlightedText">0.86,</span> entering a zone historically linked with recessions
                going back six decades.
              </p>
              <div className="imageWrapperCont">
                <div className="relatedImg">
                  <img
                    src={image6}
                    alt="gamma flip back to positive"
                  />
                  <div
                    className="zoomBtn"
                    onClick={() => handleLargeImg(image6)}
                  >
                    <button>
                      <img
                        src={zoomImg}
                        alt=""
                      />
                    </button>
                  </div>
                </div>
                <div className="relatedImg">
                  <img
                    src={image7}
                    alt="gamma flip back to positive"
                  />
                  <div
                    className="zoomBtn"
                    onClick={() => handleLargeImg(image7)}
                  >
                    <button>
                      <img
                        src={zoomImg}
                        alt=""
                      />
                    </button>
                  </div>
                </div>
              </div>
              <p>This has now become one of the key macro charts the analyst is watching into early 2026.</p>
              <p className="highlightedText">China’s Complex Bottom</p>
              <p>China’s factory activity shows tentative signs of firming — a potential early-cycle stabilisation.</p>
              <div className="imageWrapperCont">
                <div className="relatedImg">
                  <img
                    src={image15New}
                    alt="China edging up?"
                  />
                  <div
                    className="zoomBtn"
                    onClick={() => handleLargeImg(image15New)}
                  >
                    <button>
                      <img
                        src={zoomImg}
                        alt=""
                      />
                    </button>
                  </div>
                </div>
              </div>
              <p>
                Combined with deflationary export momentum from its record surplus, China becomes a quiet macro wildcard — both a support for global disinflation and a potential driver of industrial
                sentiment.
              </p>
              <p className="highlightedText">Europe Turns Hawkish</p>
              <p>The ECB signalled a surprisingly hawkish stance, noting that future moves could include rate hikes, even as Switzerland posted near-zero inflation — the lowest in years.</p>
              <div className="imageWrapperCont">
                <div className="relatedImg">
                  <img
                    src={image16}
                    alt="SNB deflation worries"
                  />
                  <div
                    className="zoomBtn"
                    onClick={() => handleLargeImg(image16)}
                  >
                    <button>
                      <img
                        src={zoomImg}
                        alt=""
                      />
                    </button>
                  </div>
                </div>
              </div>
              <p>
                The result is a global macro landscape dominated by <span className="highlightedText">contradictions</span> ahead of the FOMC.
              </p>
            </div>
          </div>
        </div>
        <hr className="divisionLine" />
        <div className="subHeader">
          <div className="contentDivWrapper flexDiv">
            <div className="contentDiv listOfRecap">
              <p className="highlightedBoldText">Technical & Sentiment Breakdown: Pre-Santa Chop Meets Flow Support</p>
              <p>Technical conditions improved meaningfully, though they remain short-term choppy.</p>
              <p>
                Broad-market internals strengthened as cyclicals, tech, and defensives all participated in the rebound. SPX positioning models showed a gradual shift back toward neutral-bullish
                territory.
              </p>

              <div className="imageWrapperCont">
                <div className="relatedImg">
                  <img
                    src={image37}
                    alt="SPX set up nicely"
                  />
                  <div
                    className="zoomBtn"
                    onClick={() => handleLargeImg(image37)}
                  >
                    <button>
                      <img
                        src={zoomImg}
                        alt=""
                      />
                    </button>
                  </div>
                </div>
              </div>
              <p>Nasdaq 100 enters one of its best seasonal windows of the year — the mid-December momentum phase.</p>
              <div className="imageWrapperCont">
                <div className="relatedImg">
                  <img
                    src={image18}
                    alt="Nas100 set to boom"
                  />
                  <div
                    className="zoomBtn"
                    onClick={() => handleLargeImg(image18)}
                  >
                    <button>
                      <img
                        src={zoomImg}
                        alt=""
                      />
                    </button>
                  </div>
                </div>
              </div>
              <p>Short-interest baskets bounced as covering accelerated, signalling improved risk appetite across weaker pockets of the market.</p>
              <div className="imageWrapperCont">
                <div className="relatedImg">
                  <img
                    src={image20}
                    alt="most shorted back in squeeze mode"
                  />
                  <div
                    className="zoomBtn"
                    onClick={() => handleLargeImg(image20)}
                  >
                    <button>
                      <img
                        src={zoomImg}
                        alt=""
                      />
                    </button>
                  </div>
                </div>
              </div>
              <p>
                Seasonality models continue to highlight <span className="highlightedText">Day 11 of December</span> as the key inflexion point for historically reliable upside follow-through.
              </p>
              <div className="imageWrapperCont">
                <div className="relatedImg">
                  <img
                    src={image26}
                    alt="Longview says buy day 11 in Dec"
                  />
                  <div
                    className="zoomBtn"
                    onClick={() => handleLargeImg(image26)}
                  >
                    <button>
                      <img
                        src={zoomImg}
                        alt=""
                      />
                    </button>
                  </div>
                </div>
              </div>
              <p>The analyst’s view: the next few days may remain noisy, but the broader structure ahead of mid-December looks supportive.</p>
            </div>
          </div>
        </div>
        <hr className="divisionLine" />
        <div className="subHeader">
          <div className="contentDivWrapper">
            <div className="contentDiv listOfRecap">
              <p className="highlightedBoldText">Last Week’s Recap: Labour Softness, Crypto Stress, and Internal Stabilisation</p>
              <p>
                Markets kicked off on unstable footing as crypto liquidations, Treasury settlement pressures, and mixed macro data dragged risk lower. But as the week progressed, flows stabilised,
                volatility collapsed, and improving internals helped equities regain their footing into Friday.
              </p>
              <p className="highlightedText">Key Highlights:</p>
              <ul className="pointersSection">
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">Macro: </span>
                    <br></br>Labour remained soft beneath the surface, with ADP signalling continued slowing among smaller firms. Sentiment indicators showed tentative signs of bottoming, while
                    jobless claims surprised by dropping to their lowest since 2022.
                  </p>
                  <div className="imageWrapperCont">
                    <div className="relatedImg">
                      <img
                        src={image14}
                        alt="ADP suggesting new lower normal"
                      />
                      <div
                        className="zoomBtn"
                        onClick={() => handleLargeImg(image14)}
                      >
                        <button>
                          <img
                            src={zoomImg}
                            alt=""
                          />
                        </button>
                      </div>
                    </div>
                  </div>
                </li>
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">China: </span>
                    <br></br>Factory activity displayed early signs of improvement, while the record trade surplus reinforced China’s growing deflationary impact on global markets.
                  </p>
                  <div className="imageWrapperCont">
                    <div className="relatedImg">
                      <img
                        src={image15New}
                        alt=" China edging up?"
                      />
                      <div
                        className="zoomBtn"
                        onClick={() => handleLargeImg(image15New)}
                      >
                        <button>
                          <img
                            src={zoomImg}
                            alt=""
                          />
                        </button>
                      </div>
                    </div>
                  </div>
                </li>
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">Flows: </span>
                    <br></br>Positioning improved as retail and ETFs absorbed supply. Institutional flows stabilised, while hedge funds remained cautious but no longer aggressively risk-off.
                  </p>
                </li>

                <div className="imageWrapperCont">
                  <div className="relatedImg">
                    <img
                      src={image32}
                      alt="ETFs dominant"
                    />
                    <div
                      className="zoomBtn"
                      onClick={() => handleLargeImg(image32)}
                    >
                      <button>
                        <img
                          src={zoomImg}
                          alt="commodities still cheap"
                        />
                      </button>
                    </div>
                  </div>
                  <div className="relatedImg">
                    <img
                      src={image33}
                      alt="retail dominant but dangerously passive"
                    />
                    <div
                      className="zoomBtn"
                      onClick={() => handleLargeImg(image33)}
                    >
                      <button>
                        <img
                          src={zoomImg}
                          alt=""
                        />
                      </button>
                    </div>
                  </div>
                </div>
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">Commodities: </span>
                    <br></br>Gold’s structural bullish setup remains intact, supported by constrained supply dynamics. Silver continued to reflect tight conditions across physical markets.
                  </p>
                </li>
                <div className="imageWrapperCont">
                  <div className="relatedImg">
                    <img
                      src={image79}
                      alt="gold supply"
                    />
                    <div
                      className="zoomBtn"
                      onClick={() => handleLargeImg(image79)}
                    >
                      <button>
                        <img
                          src={zoomImg}
                          alt=""
                        />
                      </button>
                    </div>
                  </div>
                  <div className="relatedImg">
                    <img
                      src={image82}
                      alt="silver lining your pockets"
                    />
                    <div
                      className="zoomBtn"
                      onClick={() => handleLargeImg(image82)}
                    >
                      <button>
                        <img
                          src={zoomImg}
                          alt=""
                        />
                      </button>
                    </div>
                  </div>
                </div>
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">Crypto:</span>
                    <br></br>Bitcoin faced another wave of structural volatility as “dolphin” wallets (100–1,000 BTC) sharply reduced accumulation — a key behavioural shift among mid-sized holders.
                    Liquidity issues, not fraud, were behind the move.
                  </p>
                </li>
                <div className="relatedImg">
                  <img
                    src={image86}
                    alt="Bitcoin dolphins"
                  />
                  <div
                    className="zoomBtn"
                    onClick={() => handleLargeImg(image86)}
                  >
                    <button>
                      <img
                        src={zoomImg}
                        alt=""
                      />
                    </button>
                  </div>
                </div>
              </ul>
            </div>
          </div>
        </div>
        <hr className="divisionLine" />
        <div className="subHeader">
          <div className="contentDivWrapper">
            <div className="contentDiv listOfRecap">
              <p className="highlightedBoldText">The Week Ahead: FOMC, Inflation, and a High-Stakes Policy Cluster</p>
              <p>
                A heavyweight macro calendar collides with one of the most pivotal policy weeks of Q4. With volatility suppressed and positioning light, traders face a window where data surprises and
                policy tone could quickly reprice risk assets.
              </p>
              <p className="highlightedText">Monday, Dec 8</p>
              <ul className="pointersSection">
                <li className="themesPointer">
                  <p> Japan: GDP, Wages</p>
                </li>
                <li className="themesPointer">
                  <p>China: Trade Balance, Exports</p>
                </li>
                <li className="themesPointer">
                  <p>Germany: Industrial Production</p>
                </li>
                <li className="themesPointer">
                  <p> Switzerland: SECO Consumer Climate</p>
                </li>
                <li className="themesPointer">
                  <p> U.S.: Treasury Bill Auctions</p>
                </li>
              </ul>

              <p className="highlightedText">Tuesday, Dec 9</p>
              <ul className="pointersSection">
                <li className="themesPointer">
                  <p>RBA Rate Decision</p>
                </li>
                <li className="themesPointer">
                  <p>Eurozone & German Trade Data</p>
                </li>
                <li className="themesPointer">
                  <p>NFIB Small Business Optimism</p>
                </li>
                <li className="themesPointer">
                  <p>U.S. JOLTS Job Openings</p>
                </li>
                <li className="themesPointer">
                  <p>API Oil Stock Data</p>
                </li>
                <li className="themesPointer">
                  <p>10-Year U.S. Note Auction</p>
                </li>
              </ul>

              <p className="highlightedText">Wednesday, Dec 10</p>
              <ul className="pointersSection">
                <li className="themesPointer">
                  <p>U.S. CPI</p>
                </li>
                <li className="themesPointer">
                  <p> FOMC Rate Decision, SEP, Dot Plot</p>
                </li>
                <li className="themesPointer">
                  <p>BoC Rate Decision</p>
                </li>
                <li className="themesPointer">
                  <p>Crude Oil Inventories</p>
                </li>
                <li className="themesPointer">
                  <p>U.S. Federal Budget Balance</p>
                </li>
              </ul>

              <p className="highlightedText">Thursday, Dec 11</p>
              <ul className="pointersSection">
                <li className="themesPointer">
                  <p> SNB Rate Decision</p>
                </li>
                <li className="themesPointer">
                  <p>Eurogroup Meeting</p>
                </li>
                <li className="themesPointer">
                  <p>U.S. Jobless Claims</p>
                </li>
                <li className="themesPointer">
                  <p>Canada: Trade Balance</p>
                </li>
                <li className="themesPointer">
                  <p>OPEC / IEA Monthly Reports</p>
                </li>
              </ul>

              <p className="highlightedText">Friday, Dec 12</p>
              <ul className="pointersSection">
                <li className="themesPointer">
                  <p>Global PMIs (U.S., EU, Japan, China)</p>
                </li>
                <li className="themesPointer">
                  <p>U.K.: GDP</p>
                </li>
                <li className="themesPointer">
                  <p>Eurozone: CPI for major regions</p>
                </li>
                <li className="themesPointer">
                  <p>China: M2, TSF, Loan Growth</p>
                </li>
              </ul>
            </div>
          </div>
        </div>
        <hr className="divisionLine" />
        <div className="subHeader">
          <div className="contentDivWrapper">
            <div className="contentDiv listOfRecap">
              <p className="highlightedBoldText">Alpha Takeaway: Mixed Into the Fed — Seasonal Momentum After Day 11</p>
              <p>
                The market enters the week positioned for chop, but with improving internals and strong seasonality looming. Flows have stabilised, rate expectations soften the macro backdrop, and the
                Santa window opens soon — but recession signals and geopolitical fragility still loom large.
              </p>

              <ul className="pointersSection">
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">Equities:</span>
                    <br></br>Momentum remains constructive as internals strengthen and volatility stays suppressed. Seasonal tailwinds grow stronger after the 11th trading day of December, but any
                    hawkish surprise from the Fed could quickly challenge upside follow-through.
                  </p>
                </li>
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">Gold & Silver:</span> <br></br>Gold’s structural bull case remains supported by tight supply and falling yields. Silver’s higher beta keeps it
                    attractive tactically, though it remains sensitive to liquidity swings.
                  </p>
                </li>
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">Crypto: </span> <br></br>Structural liquidity issues persist, with reduced accumulation among key mid-tier holders. Upside depends on broader risk
                    appetite and whether liquidity channels open post-FOMC.
                  </p>
                </li>

                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">Macro: </span> <br></br>The LEI/CEI recession signal demands attention, even as labour holds stable and inflation cools. If QT guidance softens
                    and yields remain capped, risk assets could extend gains into year-end — but the window is narrow and highly path-dependent.
                  </p>
                </li>
              </ul>

              <div className="imageWrapperCont">
                <div className="relatedImg">
                  <img
                    src={image6}
                    alt=" Albert warning LEI/CEI"
                  />
                  <div
                    className="zoomBtn"
                    onClick={() => handleLargeImg(image6)}
                  >
                    <button>
                      <img
                        src={zoomImg}
                        alt=""
                      />
                    </button>
                  </div>
                </div>
                <div className="relatedImg">
                  <img
                    src={image79}
                    alt="gold supply"
                  />
                  <div
                    className="zoomBtn"
                    onClick={() => handleLargeImg(image79)}
                  >
                    <button>
                      <img
                        src={zoomImg}
                        alt=""
                      />
                    </button>
                  </div>
                </div>
                <div className="relatedImg">
                  <img
                    src={image86}
                    alt="Bitcoin dolphins"
                  />
                  <div
                    className="zoomBtn"
                    onClick={() => handleLargeImg(image86)}
                  >
                    <button>
                      <img
                        src={zoomImg}
                        alt=""
                      />
                    </button>
                  </div>
                </div>
              </div>
              <p>
                <span className="highlightedText">
                  “Expect chop into the Fed — but once the calendar clears and seasonality turns on, the path of least resistance becomes higher. The window is narrow, but the opportunity is real.”
                </span>
              </p>
            </div>
          </div>
        </div>
        <div className="button_wrapper">
          <button
            className="gradientButton_small "
            onClick={() => {
              handleRedirect("https://docs.google.com/document/d/120vmXopihxRoYjRqLA8xTLq52SLo2IHY9xkwnhvxNOQ/edit?tab=t.0");
            }}
          >
            Read In-Depth Market Outlook
          </button>
        </div>
        <hr className="divisionLine" />
      </div>
      {selectedImage && (
        <BlogImagePopper
          image={selectedImage}
          onClose={() => handleLargeImg(null)}
        />
      )}
    </div>
  );
};

export default Blog46;
